import { render, staticRenderFns } from "./TermlyReport.vue?vue&type=template&id=24fa96ee&scoped=true"
import script from "./TermlyReport.vue?vue&type=script&lang=js"
export * from "./TermlyReport.vue?vue&type=script&lang=js"
import style0 from "./TermlyReport.vue?vue&type=style&index=0&id=24fa96ee&prod&lang=scss&scoped=true"
import style1 from "./TermlyReport.vue?vue&type=style&index=1&id=24fa96ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fa96ee",
  null
  
)

export default component.exports